export default "__VITE_ASSET__6bb8aed1__"